<template>
<div>
    <b-overlay :show="loading" :opacity="0.4">
        <form class="change-password-form" @submit.prevent="processUpdatePassword" method="post">
            <h4 class="change-password-form__title">{{ TEXTS.render(`CHANGE_PASSWORD_HEADER`) }}</h4>
            <p class="change-password-form__desc">{{ TEXTS.render(`CHANGE_PASSWORD_SUBHEADER`) }}</p>
            <p class="text-danger font-sm font-weight-bold" v-html="error"></p>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1">{{ TEXTS.render(`CHANGE_PASSWORD_OLD_PASSWORD_HEADER`) }}</label>
                        <input type="hidden" name="username" disabled />
                        <input type="password" autocomplete="current-password" class="form-control" v-model="details.oldPassword" @keydown.enter.prevent="" :placeholder="TEXTS.render(`CHANGE_PASSWORD_OLD_PASSWORD_PLACEHOLDER`)" />
                        <div class="register-form__validation text-danger font-weight-bold" v-html="validations.oldPassword" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1">{{ TEXTS.render(`CHANGE_PASSWORD_NEW_PASSWORD_HEADER`) }}</label>
                        <input type="password" autocomplete="new-password" class="form-control" v-model="details.newPassword" @keydown.enter.prevent="" :placeholder="TEXTS.render(`CHANGE_PASSWORD_NEW_PASSWORD_HEADER`)" />
                        <div class="register-form__validation text-danger font-weight-bold" v-html="validations.newPassword" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1">{{ TEXTS.render(`CHANGE_PASSWORD_RETYPE_PASSWORD_HEADER`) }}</label>
                        <input type="password" autocomplete="new-password" class="form-control" v-model="details.retypeNewPassword" @keydown.enter.prevent="" :placeholder="TEXTS.render(`CHANGE_PASSWORD_RETYPE_PASSWORD_PLACEHOLDER`)" />
                        <div class="register-form__validation text-danger font-weight-bold" v-html="validations.retypeNewPassword" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <ColoredButton type="submit" id="passwordUpdateBtn">{{ TEXTS.render(`CHANGE_PASSWORD_BTN_CHANGE_PASSWORD`) }}</ColoredButton>
                </div>
            </div>
        </form>
    </b-overlay>
    <UpdatePasswordModal modalId="confirmUpdatePasswordModal" triggerEventName="confirmUpdatePasswordSuccess"/>
</div>
</template>

<script>
    import UpdatePasswordModal from '../../../../common/components/UpdatePasswordModal';
    import ColoredButton from '../../../../common/components/ColoredButton';
    import Texts from '../../../../common/utils/Texts'
    export default {
        components: {
            UpdatePasswordModal,
            ColoredButton
        },
        data() {
            return {
                details: {
                    oldPassword: '',
                    newPassword: '',
                    retypeNewPassword: ''
                },
                validations: {
                    oldPassword: '',
                    newPassword: '',
                    retypeNewPassword: '',
                    valid: true
                }
            }
        },
        mounted() {
            this.$store.commit('SET_UPDATE_PASSWORD', {
                error: '',
                success: false,
                loading: false
            })
        },
        methods: {
            resetForm() {
                this.details.oldPassword = '';
                this.details.newPassword = '';
                this.details.retypeNewPassword = '';
            },
            resetValidation() {
                for (const key in this.validations) {
                    if (this.validations.hasOwnProperty(key)) {
                        if (typeof key === 'string') {
                            this.validations[key] = '';
                            continue;
                        }
                    }
                }
                this.validations.valid = true;
            },
            validate(event) {
                this.resetValidation();
                if (!(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,60}$/.test(this.details.oldPassword))) {
                    this.validations.valid = false;
                    this.validations.oldPassword = Texts.render(`CHANGE_PASSWORD_VALIDATION_PASSWORD`);
                }
                if (!(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,60}$/.test(this.details.newPassword))) {
                    this.validations.valid = false;
                    this.validations.newPassword = Texts.render(`CHANGE_PASSWORD_VALIDATION_NEW_PASSWORD`);
                }
                if (this.validations.valid && this.details.oldPassword.trim() === this.details.newPassword.trim()) {
                    this.validations.valid = false;
                    this.validations.newPassword = Texts.render(`CHANGE_PASSWORD_VALIDATION_SAME_PASSWORD`);
                }
                if (this.details.newPassword && this.details.newPassword !== this.details.retypeNewPassword) {
                    this.validations.valid = false;
                    this.validations.retypeNewPassword = Texts.render(`CHANGE_PASSWORD_VALIDATION_RETYPE`);
                }
            },
            processUpdatePassword(event) {
                this.validate();

                if (this.validations.valid) {
                    this.$store.dispatch('updatePassword', {
                        password: this.details.oldPassword,
                        newpassword: this.details.newPassword
                    });
                }
            },
            updatePasswordSuccess() {
                $('#updatePasswordSuccess').modalbs5({
                    backdrop: 'static',
                    keyboard: false
                })
            }
        },
        computed: {
            TEXTS : ()=> Texts,
            loading() {
                return this.$store.getters['GET_UPDATE_PASSWORD'].loading;
            },
            error() {
                return this.$store.getters['GET_UPDATE_PASSWORD'].error;
            },
            onSuccess() {
                return this.$store.getters['GET_UPDATE_PASSWORD'].success;
            }
        },
        watch: {
            'onSuccess': function(v) {
                if (v) {
                    this.resetForm();
                    this.updatePasswordSuccess();
                }
            }
        },
    }
</script>
